import React from 'react';
import { Button, TopActionBar } from '../components';
``;
import { ModuleBridge } from '../components';

export const MoveGroups = () => {
    return (
        <>
            <TopActionBar>
                <div>
                    <Button type="primary" className="button button--primary" onClick={() => window.editMoveGroup()}>
                        Add Application or Move Group
                    </Button>
                </div>
            </TopActionBar>
            <div id="move_groups_container"></div>
            <ModuleBridge moduleId="move_groups_list_module" />
        </>
    );
};
